  const url="http://sis.ashia.sn/sis/"
 // const url="http://192.99.37.218/sis/"
  // const url="http://localhost:3000/"
  //const url="http://dev-sis.ashia.sn/sis/"

export default url